import { useGetWorkflowStepsQuery } from '../redux/services/api';

const useFetchWorkflowSteps = (formId: number) => {
  const {
    data: workflowSteps,
    isFetching: isFetchingWorkflowSteps,
    error: workflowStepsError,
  } = useGetWorkflowStepsQuery(
    {
      formId,
      filters: {
        archived: { value: false, comparison: '=' },
      },
    },
    {
      skip: formId === undefined || formId <= 0,
    }
  );

  return { workflowSteps, isFetchingWorkflowSteps, workflowStepsError };
};

export default useFetchWorkflowSteps;
